module.exports = __webpack_public_path__ + "static/media/microbit-back.a25934ef.gif";